import { post } from "mdui/api/HttpReq";

const getExchangeRate = async ({ props, formData, updateState, config, setCfg, ...data }) => {
    let val = await post('exchg-rate-cal', 'list', formData);
    let newFormData = { ...formData };

    if (val) {
        newFormData = {
            ...formData,
            ...val
        }
    }
    let {procMode, ...restFormData} = newFormData;
    let attr = await buildAttr({ formData: restFormData, args: 'rate' })
    return { newFormData: restFormData, newAttr: attr }
}

const getExchangeRateNonSwift = async ({ props, formData, updateState, config, setCfg,clearForm,loadCfg, modNm, mtype, ...data }) => {

    let val = await post('exchg-rate-cal', 'list', formData);
    let newFormData = { ...formData };

    if (val) {
        newFormData = {
            ...formData,
            ...val
        }
    }
    let {procMode, ...restFormData} = newFormData;
   updateState({ newFormData: restFormData })
}

const buildAttr = async ({ formData, args }) => {
    if (args === undefined) {
        return {};
    }                                                                                                   
    const { debitCcy: debitccy, creditCcy: creditccy, fxContractRefNum, baseCcy, chrgBr } = formData

    const hasFxRef = fxContractRefNum && fxContractRefNum !== ''

    let xchgRate, debitRate, creditRate

    if (hasFxRef) {
        if (debitccy === undefined && creditccy === undefined) return
        if (debitccy !== creditccy && baseCcy !== debitccy && baseCcy !== creditccy) {
            xchgRate = { readOnly: false }
            debitRate = { readOnly: true }
            creditRate = { readOnly: true }
        } else if (baseCcy === debitccy) {
            creditRate = { readOnly: false }
            debitRate = { readOnly: true }
        } else if (baseCcy === creditccy) {
            creditRate = { readOnly: true }
            debitRate = { readOnly: false }
        }
    } else {
        xchgRate = debitRate = creditRate = { readOnly: true }
    }

    const isFCYLike = debitccy === creditccy && baseCcy !== debitccy
    const isCred = chrgBr === 'CRED'
    const isDebt = chrgBr === 'DEBT'
    const cdtRO = { readOnly: !isCred }
    const debtRO = { readOnly: isCred }
    const showAgnt = !isCred && isDebt

    let attr = {}
    if (args && args === 'chrgBr') {
        attr = {
            cdtCommH: cdtRO,
            cdtCableFee: cdtRO,
            cdtagntFee: cdtRO,
            commH: debtRO,
            cableFee: debtRO,
            agntFee: { ...debtRO, hide: !showAgnt },
            flatFeeFrAgnt: { hide: !showAgnt },
            commIL: { ...debtRO, hide: !isFCYLike },
            cdtCommIL: { ...cdtRO, hide: !isFCYLike },
            flatFeeFrCommIL: { hide: !isFCYLike },
        }
    } else if (args && args === 'ccy') {
        attr = {
            fxContractRefNum: { readOnly: debitccy === creditccy },
            xchgRate,
            debitRate,
            creditRate
        }
    }
    return attr;
}

const hndlFxCrtRefNum = async ({ props, formData, updateState, config, setCfg, ...data }) => {
    let attr = await buildAttr({ formData, args: 'ccy' })
    updateState({ newFormData: formData, newAttr: attr })
}

const cbftChrgBrFeeCal = async ({ props, formData, updateState, config, setCfg, ...data }) => {
    //removing debitAmt from formData to avoid unnecessary calculations
    const {debitAmt, errors, ...reducer} = formData
    const val = await post('fee-cal', 'list', {...reducer, module: props.field.moduleId})
    if (!val) return
    let args = props.field.callbackArgs
    const attr = await buildAttr({ formData, args })
    let nattr = { ...attr }
    let {errors: valErrors, ...restVal} = val
    if (valErrors && typeof valErrors === 'object') {
        let fields = ['creditAmt']

    // Reset fields from original attr without err
    for (let field of fields) {
        if (data.attr?.[field]) {
            let originalAttr = { ...data.attr[field] }
            delete originalAttr.err
            nattr[field] = originalAttr
        }
    }
    for (let [fieldName, errorCode] of Object.entries(valErrors)) {
                let attributes = nattr[fieldName] || {}
                delete attributes['err'];
                nattr[fieldName] = { ...attributes, err: errorCode };
        }
        
    }
    const { procMode, ...restFormData } = { ...formData, ...restVal }
    updateState({ newFormData: restFormData, newAttr: nattr })
}

const hndlCntryCd = async ({ props, formData, updateState, config, setCfg, ...data }) => {
    console.log('feeCalculation formData', formData)
    let newFormData = { ...formData }
    if (formData && formData.dbtrCntrycd && formData.dbtrCntrycd === 'SG') {
        newFormData = {
            ...newFormData,
            dbtrTwnNm: 'Singapore'
        }
    }

    if (formData && formData.cdtrCntryCd && formData.cdtrCntryCd === 'SG') {
        newFormData = {
            ...newFormData,
            cdtrTwnNm: 'Singapore'
        }
    }
    updateState({ newFormData })


}

const blkPrepSummary = async ({ props, formData, updateState, config, setCfg, values, responseData, ...data }) => {
    console.log(responseData);
    let newValues = {...values, totRec: responseData?.WUI_ROWS_COUNT}
    return newValues;
}

const blkPrepAmtSummary = async ({ props, formData, updateState, config, setCfg, values, responseData, ...data }) => {
    console.log("blkPrepAmtSummary", responseData);
    let newValues = {...values, totRec: responseData?.WUI_ROWS_COUNT, totAmt: responseData?.totAmt.toFixed(2)}
    return newValues;
}
const hndlAcctFrToValidation = async ({ props, formData, updateState, config, setCfg, ...data }) => {
    const { acctFr, acctTo } = formData

    let attr = { ...(data.attr || {}) }
    let acctToAttr = { ...(attr.acctTo || {}) }

    if (acctFr && acctTo && acctFr === acctTo) {
        acctToAttr = { ...acctToAttr, err: 'ACCT_FR_TO_SAME' }
    } else {
        delete acctToAttr.err
    }

    attr = { ...attr, acctTo: acctToAttr }
    updateState({ newFormData: formData, newAttr: attr })
}

export { cbftChrgBrFeeCal, hndlCntryCd, getExchangeRate, hndlFxCrtRefNum, blkPrepSummary, blkPrepAmtSummary, getExchangeRateNonSwift, buildAttr, hndlAcctFrToValidation }